export const GET_ALL_FACTURE_REQUEST = "GET_ALL_FACTURE_REQUEST";
export const GET_ALL_FACTURE_SUCCESS = "GET_ALL_FACTURE_SUCCESS";
export const GET_ALL_FACTURE_FAIL = "GET_ALL_FACTURE_FAIL";

export const GET_FACTURE_REQUEST = "GET_FACTURE_REQUEST";
export const GET_FACTURE_SUCCESS = "GET_FACTURE_SUCCESS";
export const GET_FACTURE_FAIL = "GET_FACTURE_FAIL";

export const ADD_FACTURE_REQUEST = "ADD_FACTURE_REQUEST";
export const ADD_FACTURE_SUCCESS = "ADD_FACTURE_SUCCESS";
export const ADD_FACTURE_FAIL = "ADD_FACTURE_FAIL";

export const UPDATE_FACTURE_REQUEST = "UPDATE_FACTURE_REQUEST";
export const UPDATE_FACTURE_SUCCESS = "UPDATE_FACTURE_SUCCESS";
export const UPDATE_FACTURE_FAIL = "UPDATE_FACTURE_FAIL";

export const DELETE_FACTURE_REQUEST = "DELETE_FACTURE_REQUEST";
export const DELETE_FACTURE_SUCCESS = "DELETE_FACTURE_SUCCESS";
export const DELETE_FACTURE_FAIL = "DELETE_FACTURE_FAIL";

export const ADD_FATCARTICLE_REQUEST = "ADD_FATCARTICLE_REQUEST";
export const ADD_FATCARTICLE_SUCCESS = "ADD_FATCARTICLE_SUCCESS";
export const ADD_FATCARTICLE_FAIL = "ADD_FATCARTICLE_FAIL";

export const GET_FATCARTICLE_REQUEST = "GET_FATCARTICLE_REQUEST";
export const GET_FATCARTICLE_SUCCESS = "GET_FATCARTICLE_SUCCESS";
export const GET_FATCARTICLE_FAIL = "GET_FATCARTICLE_FAIL";

export const UPDATE_FATCARTICLE_REQUEST = "UPDATE_FATCARTICLE_REQUEST";
export const UPDATE_FATCARTICLE_SUCCESS = "UPDATE_FATCARTICLE_SUCCESS";
export const UPDATE_FATCARTICLE_FAIL = "UPDATE_FATCARTICLE_FAIL";

export const DELETE_FATCARTICLE_REQUEST = "DELETE_FATCARTICLE_REQUEST";
export const DELETE_FATCARTICLE_SUCCESS = "DELETE_FATCARTICLE_SUCCESS";
export const DELETE_FATCARTICLE_FAIL = "DELETE_FATCARTICLE_FAIL";
